import { useCallback } from 'react';

import { TNavItemSize, Tabs } from '@treezor/design-system';

import { ITab } from '@/store/models/profile.model';

import { useNavigationTabs } from './useNavigationTabs';

type TProps = {
  items: ITab[];
  size?: TNavItemSize;
  onTabChanged?: (index: number) => void;
  className?: string;
  scrollStepRatio?: number;
};

export function NavigationTabs({ items, size, onTabChanged, className, scrollStepRatio }: TProps) {
  const { handleRouteChange, currentTabIndex } = useNavigationTabs({ items });

  const hanldeTabChanged = useCallback(
    (index) => {
      handleRouteChange(index);
      onTabChanged?.(index);
    },
    [handleRouteChange, onTabChanged],
  );

  return (
    <Tabs
      items={items}
      size={size}
      onTabChanged={hanldeTabChanged}
      currentTabIndex={currentTabIndex}
      className={className}
      scrollStepRatio={scrollStepRatio}
    />
  );
}
